// extracted by mini-css-extract-plugin
export default {"button":"Button_button__jeqas","buttonLoad":"Button_buttonLoad__3WDWt"};